import React, { Component } from "react";
import AppModalBs from "../../../partials/AppModalBs";

export default class ReportsScheduledModal extends Component {
  render() {
    let { id = "reportsScheduledModal" } = this.props;
    return (
      <AppModalBs id={id} hideHeader={true} contentClass="border-0 rounded-4 shadow p-4 text-center" size="modal-md">
        <div className="position-relative">
          <button type="button" className="btn-close position-absolute top-0 end-0" data-bs-dismiss="modal" aria-label="Close" style={{ right: '-10px', top: '-10px' }}></button>
          
          <div className="mx-auto mb-4 mt-3 d-flex align-items-center justify-content-center" style={{ width: '70px', height: '70px', backgroundColor: '#ff9800', borderRadius: '50%', color: 'white' }}>
            <i className="fa fa-check" style={{ fontSize: '30px' }}></i>
          </div>
          
          <h4 className="fw-bold text-dark mb-4">Reports Scheduled Successfully!</h4>
          
          <p className="text-dark mb-4 mx-auto" style={{ fontSize: '15px', lineHeight: '1.6', maxWidth: '400px' }}>
            The reports have been successfully scheduled for generation. They will be processed by the nightly scheduled job and will be available tomorrow morning.
          </p>
          
          <button className="btn btn-warning text-white fw-bold px-5 py-2 mb-2" data-bs-dismiss="modal" style={{ backgroundColor: '#ff9800', borderColor: '#ff9800', borderRadius: '6px' }}>
            Ok , Got It
          </button>
        </div>
      </AppModalBs>
    );
  }
}
